import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'
import { ImageStore } from 'store/item/ImageStore'
import { RecStore } from 'store/item/RecStore'
import { opt } from 'store/opt'
import { Item } from 'type/Item'

export type ItemStep =
  | 'none'
  | 'combine'
  | 'brand'
  | 'color'
  | 'category'
  | 'price'

export class ItemStore {
  readonly json: Item
  readonly image: ImageStore
  private _step: ItemStep = 'none'
  readonly rec: RecStore

  constructor(json: Item) {
    makeAutoObservable(this)
    this.json = json
    this.image = new ImageStore(json.item_full_image)
    this.rec = new RecStore(json)
  }

  get step(): ItemStep {
    return this._step
  }

  set step(value: ItemStep) {
    this._step = value
    if (value === 'none') {
      this.rec.reset()
    }
  }

  openCombine() {
    this._step = 'combine'
    void this.rec.load()
  }

  get combine(): boolean {
    const { combine, external_item_id } = this.json
    if (opt.company === 'tsum_cs') {
      return !!combine && !!external_item_id
    } else {
      return !!combine
    }
  }

  applyBrand() {
    this.rec.brand.apply()
    this.step = 'combine'
    void this.rec.search()
  }

  applyColor() {
    this.rec.color.apply()
    this.step = 'combine'
    void this.rec.search()
  }

  applyCategory() {
    this.rec.category.apply()
    this.step = 'combine'
    void this.rec.search()
  }

  applyPrice() {
    this.rec.min_price.apply()
    this.rec.max_price.apply()
    this.step = 'combine'
    void this.rec.search()
  }

  clearBrand() {
    this.rec.brand.reset()
    this.step = 'combine'
    void this.rec.search()
  }

  clearColor() {
    this.rec.color.reset()
    this.step = 'combine'
    void this.rec.search()
  }

  clearCategory() {
    this.rec.category.reset()
    this.step = 'combine'
    void this.rec.search()
  }

  clearPrices() {
    this.rec.min_price.reset()
    this.rec.max_price.reset()
    this.step = 'combine'
    void this.rec.search()
  }
}

export const item_main = mx.ref<ItemStore>()
